import { SearchTGSynonyms } from "../../search/search.util.js";
import getSnapshots from "./defiantSnapshots.js";
import { performDrugSearch } from "../../../components/drugIndexModalSearch.util.js";
import SearchXPathSimplified from "./searchXPathSimplified.js";
import { formatTopicResults } from "./formatter/formatTopicResults.js";
import { formatDrugResults } from "./formatter/formatDrugResults.js";
import { isNullOrEmpty } from "../../../utils/isNullOrEmpty";

const SORT_BY_RELEVANCE = 0;
const SORT_BY_ASCENDING = 1;
const SORT_BY_DESCENDING = 2;

const sortOrder = {
  relevance: SORT_BY_RELEVANCE,
  titleAsc: SORT_BY_ASCENDING,
  titleDesc: SORT_BY_DESCENDING,
};

function sortByResults(results, sortByString) {
  let sortBy = sortOrder[sortByString];

  Object.keys(results).forEach((key) => {
    switch (sortBy) {
      case SORT_BY_DESCENDING: {
        results[key].sort((a, b) => {
          let aValue = a.s;
          let bValue = b.s;
          if (key === "drugs") {
            aValue = a.d[Object.keys(a.d)[0]];
            bValue = b.d[Object.keys(b.d)[0]];
          }
          return aValue < bValue ? 1 : -1;
        });
        break;
      }
      default: {
        results[key].sort((a, b) => {
          let aValue = a.s;
          let bValue = b.s;
          if (key === "drugs") {
            aValue = a.d[Object.keys(a.d)[0]];
            bValue = b.d[Object.keys(b.d)[0]];
          }
          return bValue < aValue ? 1 : -1;
        });
        break;
      }
    }
  });

  return results;
}

async function performSearch({ searchText: searchTerm, sortBy = "relevance" }) {
  let synIndex = [];
  console.time("offlineSearch - performSearch");

  let synonymSearchTerm = searchTerm;
  console.time("offlineSearch - synonymSearchTerm");
  synIndex = SearchTGSynonyms(synonymSearchTerm, window.tgg);
  console.timeEnd("offlineSearch - synonymSearchTerm");

  const searchResults = {
    topics: [],
    drugs: [],
  };

  searchResults.topics = await SearchXPathSimplified(searchTerm, synIndex, true);

  const { guidelinesSnapshot: gSnapshot } = await getSnapshots();
  searchResults.drugs = performDrugSearch(searchTerm, gSnapshot);
  searchResults.drugs = searchResults.drugs.flattedResults;

  console.timeEnd("offlineSearch - performSearch");

  return sortByResults(searchResults, sortBy);
}

function getGuidelineFacets(topicResults) {
  return topicResults
    .map((topicResult) => `${topicResult.g}`)
    .reduce((acc, guideline) => {
      if (!acc[guideline]) {
        acc[guideline] = 1;
      } else {
        acc[guideline]++;
      }
      return acc;
    }, {});
}

function filterTopicByGuidelineFacet(guidelineFacet, searchResults) {
  function filterByGuidelineFacet() {
    return (topicResults) => {
      const guideline = topicResults.g;
      if (!isNullOrEmpty(guidelineFacet)) {
        return guidelineFacet === guideline;
      } else {
        return true;
      }
    };
  }

  return searchResults.filter(filterByGuidelineFacet());
}

async function format(searchResults, searchParams) {
  console.time("offlineSearch - format");
  const { guidelinesSnapshot: gSnapshot, topicSnapshot: tSnapshot } = await getSnapshots();

  const { guidelineFacet } = searchParams;
  const topicsToProcess = filterTopicByGuidelineFacet(guidelineFacet, searchResults.topics);

  const guidelineFacets = getGuidelineFacets(topicsToProcess);
  const topicResults = formatTopicResults(topicsToProcess, searchParams);
  const drugResults = formatDrugResults(searchResults, gSnapshot, tSnapshot);
  console.timeEnd("offlineSearch - format");
  return {
    topicResults: {
      totalCount: topicsToProcess.length,
      guidelineFacets: guidelineFacets,
      results: topicResults,
    },
    drugResults: drugResults,
  };
}

async function offlineSearchCombined(searchParams) {
  const { searchText } = searchParams;
  searchParams.searchText = searchParams.searchText.toLowerCase();
  console.log("Performing offline search combined for: ", searchText);
  try {
    const results = await performSearch(searchParams);
    return await format(results, searchParams);
  } catch (e) {
    console.error("Error in offlineSearchCombined:", e);
    throw e;
  }
}

export { offlineSearchCombined };
